{
 "areas": [
  {
   "id": "z01-grain-court",
   "name": "Grain Court",
   "zone": "Z01",
   "beatId": "beat:z01-grain-court",
   "anchor": [
    704,
    528
   ],
   "image": "/assets/painted/z01-grain-court.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    704,
    528
   ],
   "arrival": [
    704,
    528
   ],
   "walkable": [
    [
     [
      110,
      440
     ],
     [
      420,
      345
     ],
     [
      700,
      270
     ],
     [
      780,
      295
     ],
     [
      800,
      345
     ],
     [
      950,
      372
     ],
     [
      1090,
      452
     ],
     [
      1160,
      475
     ],
     [
      1165,
      540
     ],
     [
      1300,
      545
     ],
     [
      1320,
      470
     ],
     [
      1410,
      420
     ],
     [
      1450,
      400
     ],
     [
      1500,
      420
     ],
     [
      1500,
      445
     ],
     [
      1505,
      520
     ],
     [
      1440,
      560
     ],
     [
      1440,
      700
     ],
     [
      1330,
      720
     ],
     [
      1280,
      640
     ],
     [
      1150,
      620
     ],
     [
      1040,
      625
     ],
     [
      900,
      700
     ],
     [
      760,
      700
     ],
     [
      640,
      650
     ],
     [
      520,
      620
     ],
     [
      470,
      570
     ],
     [
      440,
      580
     ],
     [
      430,
      640
     ],
     [
      320,
      640
     ],
     [
      300,
      570
     ],
     [
      250,
      520
     ],
     [
      160,
      480
     ]
    ],
    [
     [
      305,
      628
     ],
     [
      400,
      628
     ],
     [
      400,
      800
     ],
     [
      445,
      850
     ],
     [
      500,
      950
     ],
     [
      440,
      968
     ],
     [
      400,
      915
     ],
     [
      345,
      850
     ],
     [
      310,
      800
     ]
    ],
    [
     [
      900,
      700
     ],
     [
      1010,
      645
     ],
     [
      1085,
      810
     ],
     [
      975,
      830
     ]
    ]
   ],
   "blocked": [
    [
     [
      600,
      280
     ],
     [
      1130,
      525
     ],
     [
      1130,
      550
     ],
     [
      600,
      305
     ]
    ],
    [
     [
      550,
      330
     ],
     [
      1055,
      585
     ],
     [
      1055,
      610
     ],
     [
      550,
      355
     ]
    ],
    [
     [
      290,
      460
     ],
     [
      352,
      468
     ],
     [
      352,
      560
     ],
     [
      290,
      550
     ]
    ],
    [
     [
      1180,
      300
     ],
     [
      1310,
      300
     ],
     [
      1310,
      470
     ],
     [
      1300,
      545
     ],
     [
      1165,
      540
     ],
     [
      1180,
      460
     ]
    ],
    [
     [
      1310,
      440
     ],
     [
      1362,
      440
     ],
     [
      1362,
      492
     ],
     [
      1310,
      492
     ]
    ],
    [
     [
      1370,
      535
     ],
     [
      1420,
      535
     ],
     [
      1420,
      590
     ],
     [
      1370,
      590
     ]
    ]
   ],
   "foregrounds": [
    {
     "polygon": [
      [
       645,
       585
      ],
      [
       695,
       585
      ],
      [
       702,
       690
      ],
      [
       640,
       690
      ]
     ],
     "depth": 700
    },
    {
     "polygon": [
      [
       440,
       520
      ],
      [
       505,
       520
      ],
      [
       505,
       705
      ],
      [
       440,
       705
      ]
     ],
     "depth": 705
    }
   ],
   "lamps": [
    [
     148,
     205
    ],
    [
     372,
     315
    ],
    [
     527,
     105
    ],
    [
     713,
     215
    ],
    [
     664,
     95
    ],
    [
     1067,
     40
    ],
    [
     1330,
     75
    ],
    [
     1505,
     80
    ],
    [
     830,
     230
    ],
    [
     953,
     280
    ],
    [
     1085,
     325
    ],
    [
     1332,
     460
    ],
    [
     1395,
     555
    ],
    [
     1215,
     680
    ],
    [
     855,
     712
    ],
    [
     588,
     370
    ],
    [
     755,
     455
    ],
    [
     963,
     560
    ],
    [
     1110,
     545
    ],
    [
     330,
     648
    ],
    [
     1465,
     350
    ]
   ],
   "water": [
    [
     [
      1440,
      560
     ],
     [
      1536,
      530
     ],
     [
      1536,
      1024
     ],
     [
      1180,
      1024
     ],
     [
      1190,
      900
     ],
     [
      1290,
      760
     ]
    ]
   ],
   "smoke": [
    [
     372,
     305
    ],
    [
     713,
     205
    ],
    [
     1332,
     450
    ],
    [
     1395,
     545
    ],
    [
     1215,
     670
    ]
   ],
   "people": [
    {
     "id": "person:z01-grain-court-0",
     "appearance": "actor-waiting-family",
     "name": "Woman in the bread queue",
     "route": [
      [
       640,
       330
      ],
      [
       900,
       450
      ]
     ]
    },
    {
     "id": "person:z01-grain-court-1",
     "appearance": "actor-z01-forum-watch",
     "name": "Forum watchman",
     "route": [
      [
       480,
       560
      ],
      [
       760,
       640
      ]
     ]
    },
    {
     "id": "person:z01-grain-court-2",
     "appearance": "actor-z01-bread-queue",
     "name": "Man in the bread queue",
     "route": [
      [
       736,
       384
      ],
      [
       960,
       480
      ]
     ]
    },
    {
     "id": "person:z01-grain-court-3",
     "appearance": "actor-z01-bread-queue",
     "name": "Man in the bread queue",
     "route": [
      [
       700,
       360
      ]
     ]
    },
    {
     "id": "person:z01-grain-court-4",
     "appearance": "actor-waiting-family",
     "name": "Woman in the bread queue",
     "route": [
      [
       780,
       400
      ]
     ]
    },
    {
     "id": "person:z01-grain-court-5",
     "appearance": "actor-z01-bread-queue",
     "name": "Man in the bread queue",
     "route": [
      [
       850,
       432
      ]
     ]
    },
    {
     "id": "person:z01-grain-court-6",
     "appearance": "actor-waiting-family",
     "name": "Woman in the bread queue",
     "route": [
      [
       920,
       466
      ]
     ]
    },
    {
     "id": "person:z01-grain-court-vasko-clerk",
     "appearance": "actor-z01-clerk",
     "name": "Advocate Vasko’s clerk",
     "route": [
      [
       1116,
       488
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z01-basilica",
     "label": "Arch to the basilica steps",
     "toBeat": "beat:z01-basilica",
     "at": [
      1456,
      432
     ],
     "text": "Through the arch, broad steps climb to the old Senate basilica."
    },
    {
     "id": "beat:z01-river-bridge",
     "label": "River stairs",
     "toBeat": "beat:z01-river-bridge",
     "at": [
      1376,
      624
     ],
     "text": "The stairs go down to the landing by the bridge."
    },
    {
     "id": "z01-residential-street",
     "label": "Street to the houses",
     "at": [
      368,
      608
     ],
     "text": "A narrow street runs between the houses."
    },
    {
     "id": "z01-bread-register",
     "label": "The register tables",
     "at": [
      1008,
      432
     ],
     "text": "Clerks call names from wax tablets. The measures on the table are smaller than the sacks."
    }
   ],
   "props": [
    {
     "id": "z01-claimant-cart",
     "image": "/assets/painted/props/z01-claimant-cart.png",
     "at": [
      530,
      390
     ],
     "height": 120,
     "when": {
      "all": [],
      "any": [
       "z01:claimant-declared",
       "past:z01:claimant-declared"
      ],
      "none": []
     }
    }
   ]
  },
  {
   "id": "z01-basilica",
   "name": "Senate Basilica",
   "zone": "Z01",
   "beatId": "beat:z01-basilica",
   "anchor": [
    768,
    592
   ],
   "image": "/assets/painted/z01-basilica.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    768,
    592
   ],
   "arrival": [
    768,
    592
   ],
   "walkable": [
    [
     [
      430,
      515
     ],
     [
      540,
      452
     ],
     [
      560,
      372
     ],
     [
      620,
      360
     ],
     [
      650,
      440
     ],
     [
      660,
      432
     ],
     [
      700,
      392
     ],
     [
      760,
      392
     ],
     [
      770,
      300
     ],
     [
      840,
      272
     ],
     [
      930,
      262
     ],
     [
      900,
      300
     ],
     [
      880,
      390
     ],
     [
      1060,
      500
     ],
     [
      1180,
      540
     ],
     [
      1290,
      500
     ],
     [
      1440,
      450
     ],
     [
      1500,
      470
     ],
     [
      1400,
      540
     ],
     [
      1290,
      565
     ],
     [
      1200,
      605
     ],
     [
      1100,
      700
     ],
     [
      960,
      780
     ],
     [
      900,
      795
     ]
    ],
    [
     [
      500,
      622
     ],
     [
      600,
      660
     ],
     [
      690,
      700
     ],
     [
      830,
      758
     ],
     [
      885,
      800
     ],
     [
      960,
      785
     ],
     [
      995,
      830
     ],
     [
      990,
      900
     ],
     [
      905,
      905
     ],
     [
      860,
      870
     ],
     [
      815,
      862
     ],
     [
      812,
      772
     ],
     [
      745,
      772
     ],
     [
      700,
      760
     ],
     [
      660,
      730
     ],
     [
      545,
      700
     ],
     [
      505,
      672
     ]
    ]
   ],
   "blocked": [],
   "foregrounds": [
    {
     "polygon": [
      [
       380,
       470
      ],
      [
       505,
       485
      ],
      [
       505,
       955
      ],
      [
       400,
       955
      ],
      [
       400,
       600
      ],
      [
       380,
       560
      ]
     ],
     "depth": 955
    },
    {
     "polygon": [
      [
       410,
       490
      ],
      [
       905,
       760
      ],
      [
       905,
       805
      ],
      [
       410,
       540
      ]
     ],
     "depth": 805
    },
    {
     "polygon": [
      [
       955,
       770
      ],
      [
       1290,
       630
      ],
      [
       1290,
       675
      ],
      [
       955,
       815
      ]
     ],
     "depth": 815
    }
   ],
   "lamps": [
    [
     195,
     300
    ],
    [
     340,
     488
    ],
    [
     620,
     610
    ],
    [
     582,
     178
    ],
    [
     778,
     242
    ],
    [
     972,
     258
    ],
    [
     1236,
     285
    ],
    [
     1305,
     410
    ],
    [
     88,
     150
    ],
    [
     298,
     178
    ],
    [
     718,
     82
    ],
    [
     1490,
     280
    ],
    [
     918,
     180
    ],
    [
     84,
     790
    ],
    [
     1282,
     870
    ]
   ],
   "water": [],
   "smoke": [
    [
     195,
     292
    ],
    [
     340,
     480
    ],
    [
     620,
     602
    ],
    [
     582,
     170
    ],
    [
     778,
     234
    ],
    [
     972,
     250
    ],
    [
     1305,
     402
    ],
    [
     84,
     782
    ]
   ],
   "people": [
    {
     "id": "person:z01-basilica-0",
     "appearance": "actor-z01-forum-watch",
     "name": "Watch at the dais",
     "route": [
      [
       640,
       560
      ],
      [
       760,
       500
      ]
     ]
    },
    {
     "id": "person:z01-basilica-1",
     "appearance": "actor-z01-clerk",
     "name": "Reading clerk",
     "route": [
      [
       500,
       505
      ],
      [
       524,
       494
      ]
     ]
    },
    {
     "id": "person:z01-basilica-vos",
     "appearance": "actor-ildren-vos",
     "name": "Ildren Vos",
     "route": [
      [
       650,
       528
      ]
     ],
     "when": {
      "all": [],
      "any": [
       "finale:hearing",
       "finale:court-sat"
      ],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    },
    {
     "id": "person:z01-basilica-nessa",
     "appearance": "actor-nessa-tal",
     "name": "Nessa Tal",
     "route": [
      [
       712,
       488
      ]
     ],
     "when": {
      "all": [
       "finale:nessa-witness"
      ],
      "any": [],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    }
   ],
   "landmarks": [
    {
     "id": "beat:z01-grain-court",
     "label": "Rear doors to the forum",
     "toBeat": "beat:z01-grain-court",
     "at": [
      912,
      288
     ],
     "text": "The rear doors open onto the forum and the grain court."
    },
    {
     "id": "beat:z01-archive-stair",
     "label": "Side door to the archive stair",
     "toBeat": "beat:z01-archive-stair",
     "at": [
      1456,
      464
     ],
     "text": "A side door leads down to the archive."
    },
    {
     "id": "z01-senate-dais",
     "label": "The Senate dais",
     "at": [
      592,
      448
     ],
     "text": "The old stone dais. The benches are ranked by office."
    },
    {
     "id": "z01-second-dais",
     "label": "The second dais",
     "at": [
      1040,
      480
     ],
     "text": "New timber, ochre cloth. Someone built it in a hurry and meant it to stay."
    }
   ],
   "props": [
    {
     "id": "z01-hearing-senate-dais",
     "image": "/assets/painted/props/z01-hearing-senate-dais.png",
     "at": [
      426,
      331
     ],
     "height": 131,
     "when": {
      "all": [],
      "any": [
       "finale:hearing",
       "finale:court-sat"
      ],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    },
    {
     "id": "z01-hearing-tiers",
     "image": "/assets/painted/props/z01-hearing-tiers.png",
     "at": [
      161,
      451
     ],
     "height": 201,
     "when": {
      "all": [],
      "any": [
       "finale:hearing",
       "finale:court-sat"
      ],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    },
    {
     "id": "z01-hearing-timber-dais",
     "image": "/assets/painted/props/z01-hearing-timber-dais.png",
     "at": [
      1126,
      381
     ],
     "height": 151,
     "when": {
      "all": [],
      "any": [
       "finale:hearing",
       "finale:court-sat"
      ],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    },
    {
     "id": "z01-hearing-lower-left",
     "image": "/assets/painted/props/z01-hearing-lower-left.png",
     "at": [
      666,
      1024
     ],
     "height": 514,
     "when": {
      "all": [],
      "any": [
       "finale:hearing",
       "finale:court-sat"
      ],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    },
    {
     "id": "z01-hearing-right",
     "image": "/assets/painted/props/z01-hearing-right.png",
     "at": [
      1248,
      1024
     ],
     "height": 543,
     "when": {
      "all": [],
      "any": [
       "finale:hearing",
       "finale:court-sat"
      ],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    },
    {
     "id": "z01-hearing-trestle",
     "image": "/assets/painted/props/z01-hearing-trestle.png",
     "at": [
      655,
      478
     ],
     "height": 62,
     "when": {
      "all": [],
      "any": [
       "finale:hearing",
       "finale:court-sat"
      ],
      "none": [
       "finale:n03:struck",
       "finale:n03:bought",
       "finale:n03:lost",
       "campaign:B5"
      ]
     }
    }
   ],
   "objects": [
    {
     "id": "z01-basilica-court",
     "beatId": "beat:z01-basilica",
     "name": "The Senate court",
     "at": [
      590,
      445
     ],
     "radius": 40,
     "actions": [
      "n03-hearing",
      "n03-hearing-alone",
      "n03-concede",
      "z01-petition",
      "z01-petition-standard"
     ],
     "look": "The old stone dais. The benches are ranked by office."
    },
    {
     "id": "z01-basilica-benches",
     "beatId": "beat:z01-basilica",
     "name": "The public benches",
     "at": [
      600,
      705
     ],
     "radius": 40,
     "actions": [
      "n03-court-sits"
     ],
     "look": "Plain benches below the rail, for anyone who wants to watch the Senate work."
    }
   ]
  },
  {
   "id": "z01-archive-stair",
   "name": "Archive Stair",
   "zone": "Z01",
   "beatId": "beat:z01-archive-stair",
   "anchor": [
    816,
    736
   ],
   "image": "/assets/painted/z01-archive-stair.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    816,
    736
   ],
   "arrival": [
    816,
    736
   ],
   "walkable": [
    [
     [
      240,
      140
     ],
     [
      330,
      100
     ],
     [
      470,
      82
     ],
     [
      560,
      100
     ],
     [
      610,
      195
     ],
     [
      700,
      300
     ],
     [
      870,
      510
     ],
     [
      880,
      450
     ],
     [
      1000,
      450
     ],
     [
      1030,
      520
     ],
     [
      1110,
      560
     ],
     [
      1180,
      600
     ],
     [
      1290,
      640
     ],
     [
      1300,
      730
     ],
     [
      1230,
      770
     ],
     [
      1180,
      730
     ],
     [
      1010,
      770
     ],
     [
      830,
      780
     ],
     [
      760,
      740
     ],
     [
      700,
      690
     ],
     [
      740,
      600
     ],
     [
      650,
      470
     ],
     [
      450,
      228
     ],
     [
      300,
      230
     ],
     [
      250,
      190
     ]
    ],
    [
     [
      700,
      695
     ],
     [
      760,
      740
     ],
     [
      830,
      780
     ],
     [
      834,
      800
     ],
     [
      826,
      870
     ],
     [
      720,
      880
     ],
     [
      720,
      960
     ],
     [
      650,
      960
     ],
     [
      400,
      870
     ],
     [
      310,
      830
     ],
     [
      300,
      770
     ],
     [
      385,
      770
     ],
     [
      570,
      850
     ],
     [
      705,
      855
     ],
     [
      705,
      760
     ],
     [
      690,
      720
     ]
    ]
   ],
   "blocked": [
    [
     [
      900,
      650
     ],
     [
      1010,
      630
     ],
     [
      1020,
      740
     ],
     [
      930,
      770
     ]
    ],
    [
     [
      1060,
      660
     ],
     [
      1160,
      660
     ],
     [
      1160,
      760
     ],
     [
      1070,
      770
     ]
    ],
    [
     [
      700,
      570
     ],
     [
      768,
      570
     ],
     [
      768,
      705
     ],
     [
      700,
      705
     ]
    ]
   ],
   "foregrounds": [
    {
     "polygon": [
      [
       830,
       775
      ],
      [
       1200,
       735
      ],
      [
       1200,
       1024
      ],
      [
       830,
       1024
      ]
     ],
     "depth": 780
    }
   ],
   "lamps": [
    [
     238,
     120
    ],
    [
     480,
     30
    ],
    [
     1102,
     100
    ],
    [
     785,
     292
    ],
    [
     985,
     362
    ],
    [
     792,
     380
    ],
    [
     450,
     470
    ],
    [
     735,
     550
    ],
    [
     1248,
     512
    ],
    [
     1410,
     560
    ],
    [
     996,
     650
    ],
    [
     1045,
     850
    ],
    [
     20,
     325
    ],
    [
     1398,
     318
    ]
   ],
   "water": [],
   "smoke": [
    [
     238,
     112
    ],
    [
     480,
     22
    ],
    [
     735,
     542
    ]
   ],
   "people": [
    {
     "id": "person:z01-archive-stair-0",
     "appearance": "actor-z01-clerk",
     "name": "Archivist",
     "route": [
      [
       900,
       600
      ],
      [
       1100,
       600
      ]
     ]
    },
    {
     "id": "person:z01-bond-runner",
     "appearance": "actor-z01-bond-runner",
     "name": "The advocate’s runner",
     "route": [
      [
       1168,
       720
      ]
     ],
     "when": {
      "all": [],
      "any": [],
      "none": [
       "z01:runner-beaten",
       "z01:chests-open",
       "finale:hearing"
      ]
     }
    }
   ],
   "landmarks": [
    {
     "id": "beat:z01-basilica",
     "label": "Door back to the basilica",
     "toBeat": "beat:z01-basilica",
     "at": [
      352,
      112
     ],
     "text": "The door at the top of the stair opens into the basilica."
    },
    {
     "id": "z01-archive-grille",
     "label": "The iron grille",
     "at": [
      1296,
      688
     ],
     "text": "The grille to the deeper stores stands half open. The lock is new."
    },
    {
     "id": "z01-silt-line",
     "label": "The flood line",
     "at": [
      960,
      512
     ],
     "text": "A pale line runs along every wall at the same height. Nothing is shelved below it."
    }
   ],
   "props": [
    {
     "id": "z01-runner-handcart",
     "image": "/assets/painted/props/z01-runner-handcart.png",
     "at": [
      1200,
      748
     ],
     "height": 120
    }
   ],
   "objects": [
    {
     "id": "z01-archive-bond-chests",
     "beatId": "beat:z01-archive-stair",
     "name": "The bond chests",
     "at": [
      1200,
      745
     ],
     "radius": 44,
     "actions": [
      "z01-runner-ask",
      "z01-runner-pay",
      "z01-runner-watch",
      "z01-runner-fight",
      "z01-archive-bonds"
     ],
     "look": "Iron-bound chests on a handcart, sealed with the advocate’s wax."
    },
    {
     "id": "z01-archive-flood-register",
     "beatId": "beat:z01-archive-stair",
     "name": "The flood register",
     "at": [
      930,
      700
     ],
     "radius": 44,
     "actions": [
      "z01-archive-flood"
     ],
     "look": "A pale line runs along every wall at the same height. Nothing is shelved below it."
    },
    {
     "id": "z01-archive-annex",
     "beatId": "beat:z01-archive-stair",
     "name": "The annex grille",
     "at": [
      1300,
      700
     ],
     "radius": 40,
     "actions": [
      "n03-annex-watch",
      "n03-annex-seize"
     ],
     "look": "The grille to the deeper stores stands half open. The lock is new."
    }
   ]
  },
  {
   "id": "z01-river-bridge",
   "name": "River Bridge",
   "zone": "Z01",
   "beatId": "beat:z01-river-bridge",
   "anchor": [
    640,
    480
   ],
   "image": "/assets/painted/z01-river-bridge.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    640,
    480
   ],
   "arrival": [
    640,
    480
   ],
   "walkable": [
    [
     [
      250,
      480
     ],
     [
      330,
      420
     ],
     [
      500,
      320
     ],
     [
      560,
      250
     ],
     [
      740,
      235
     ],
     [
      700,
      280
     ],
     [
      800,
      330
     ],
     [
      1100,
      245
     ],
     [
      1536,
      120
     ],
     [
      1536,
      185
     ],
     [
      1290,
      265
     ],
     [
      1040,
      350
     ],
     [
      1000,
      390
     ],
     [
      1010,
      520
     ],
     [
      990,
      620
     ],
     [
      1100,
      650
     ],
     [
      1230,
      690
     ],
     [
      1230,
      760
     ],
     [
      1100,
      800
     ],
     [
      1000,
      800
     ],
     [
      900,
      860
     ],
     [
      780,
      830
     ],
     [
      740,
      760
     ],
     [
      700,
      740
     ],
     [
      700,
      560
     ],
     [
      560,
      545
     ],
     [
      420,
      525
     ],
     [
      330,
      520
     ]
    ],
    [
     [
      415,
      525
     ],
     [
      555,
      550
     ],
     [
      550,
      625
     ],
     [
      420,
      665
     ],
     [
      300,
      660
     ],
     [
      310,
      615
     ],
     [
      405,
      600
     ]
    ]
   ],
   "blocked": [
    [
     [
      820,
      390
     ],
     [
      970,
      380
     ],
     [
      975,
      510
     ],
     [
      830,
      510
     ]
    ],
    [
     [
      890,
      640
     ],
     [
      1080,
      630
     ],
     [
      1080,
      730
     ],
     [
      900,
      730
     ]
    ],
    [
     [
      260,
      360
     ],
     [
      470,
      330
     ],
     [
      500,
      420
     ],
     [
      420,
      470
     ],
     [
      270,
      460
     ]
    ],
    [
     [
      615,
      350
     ],
     [
      760,
      350
     ],
     [
      760,
      415
     ],
     [
      615,
      415
     ]
    ]
   ],
   "foregrounds": [],
   "lamps": [
    [
     233,
     460
    ],
    [
     405,
     105
    ],
    [
     505,
     110
    ],
    [
     345,
     200
    ],
    [
     782,
     145
    ],
    [
     813,
     235
    ],
    [
     640,
     378
    ],
    [
     858,
     410
    ],
    [
     922,
     275
    ],
    [
     1113,
     195
    ],
    [
     1300,
     242
    ],
    [
     1524,
     165
    ],
    [
     997,
     595
    ],
    [
     1107,
     605
    ],
    [
     582,
     568
    ],
    [
     610,
     735
    ],
    [
     907,
     800
    ],
    [
     475,
     925
    ],
    [
     1502,
     60
    ]
   ],
   "water": [
    [
     [
      1060,
      520
     ],
     [
      1536,
      420
     ],
     [
      1536,
      1024
     ],
     [
      560,
      1024
     ],
     [
      560,
      880
     ],
     [
      1000,
      870
     ],
     [
      1250,
      790
     ],
     [
      1250,
      650
     ],
     [
      1080,
      600
     ]
    ]
   ],
   "smoke": [
    [
     233,
     452
    ],
    [
     640,
     370
    ],
    [
     858,
     402
    ],
    [
     582,
     560
    ]
   ],
   "people": [
    {
     "id": "person:z01-river-bridge-0",
     "appearance": "actor-z01-forum-watch",
     "name": "Bridge watch",
     "route": [
      [
       700,
       420
      ],
      [
       780,
       470
      ]
     ]
    },
    {
     "id": "person:z01-river-bridge-1",
     "appearance": "actor-z01-bread-queue",
     "name": "Porter",
     "route": [
      [
       800,
       700
      ],
      [
       960,
       770
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z01-grain-court",
     "label": "Steps up to the forum",
     "toBeat": "beat:z01-grain-court",
     "at": [
      624,
      272
     ],
     "text": "The steps climb past the granary to the grain court."
    },
    {
     "id": "z01-bridge-road",
     "label": "Bridge road east",
     "at": [
      1488,
      160
     ],
     "text": "The bridge carries the grain road across the Orsen."
    },
    {
     "id": "z01-river-landing",
     "label": "Towpath barge landing",
     "at": [
      1024,
      768
     ],
     "text": "Barges unload here, and the towpath barge leaves for the Lock Foot. The watch counts the sacks twice.",
     "toBeat": "beat:eastern-road-lock-foot"
    },
    {
     "id": "z01-toll-chain",
     "label": "The toll chain",
     "at": [
      736,
      432
     ],
     "text": "A chain between the lions. It is down tonight, but it is there."
    },
    {
     "id": "z01-west-road",
     "label": "Stairs down to the west road",
     "toBeat": "beat:z06-toll-shelter",
     "at": [
      340,
      640
     ],
     "text": "The stairs drop to the lower street and the imperial road west, forty-four kilometres to the Broken Causeway."
    }
   ]
  }
 ]
}
